const firebaseConfig = {
    apiKey: "AIzaSyDgasF5UrflneaFaWUAiPv6oU16KFYb3A8",
    authDomain: "paidproject-fe519.firebaseapp.com",
    projectId: "paidproject-fe519",
    storageBucket: "paidproject-fe519.appspot.com",
    messagingSenderId: "741827875631",
    appId: "1:741827875631:web:4dbe5c18bfc9208b7e07da"
  };
  export default firebaseConfig